'use client';

import { useCountDown } from 'ahooks';
import { useEffect, useState } from 'react';

export default function TimeComp({ targetTime, endCallBack }: any) {
    const [, formattedRes] = useCountDown({
        leftTime: targetTime - Date.now(),
        onEnd: () => endCallBack && endCallBack(),
    });

    const [isClient, setIsClient] = useState(false);
    const { days, hours, minutes, seconds } = formattedRes;
    useEffect(() => {
        setIsClient(true);
    }, []);
    if (!isClient) {
        return null;
    }
    return (
        <div className="eco-redeem-rewards-card-countdown">
            {days}:{hours}:{minutes}:{seconds}
        </div>
    );
}
